
import ViolinApp from "../components/ViolinApp";

export default function HomePage() {
 return <ViolinApp />;
}
